<template>
  <div class="main-container">
    <main-header></main-header>
    <sideMenu :studyData="studyData"></sideMenu>
    <div class="has-header has-sidemenu form-container">
      <!-- Search option , Add Resource option Start -->
      <div class="row">
        <div class="col-lg-7 col-md-6 col-sm-12 col-xs-12">
          <input type="text" class="form-control search-resource-field" placeholder="Search" v-model="searchResourceTerm" @keyup.enter="searchResourceList()" />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
          <div class="add_resource_btn d-flex justify-content-end">
            <button type="button" class="btn btn-resource" data-toggle="modal" data-target="#add_Resource_model" data-backdrop="static" data-keyboard="false" v-if="canSysAdminAccess || canStudyAdminAccess || canPiAccess || canSubPiAccess || canStudyCoordinatorAccess || canSupportAccess">Add Resources</button>
          </div>
        </div>
      </div>
      <!-- Search option , Add Resource option Start End-->

      <!-- Materials ,Announcements , Links Start-->
      <div class="row">
        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
          <!-- Thread notification Start -->
          <threadTrainingDashboard></threadTrainingDashboard>
          <!-- Thread notification End -->
          <!-- Materials Start -->
          <div class="materials-data">
            <div class="row material-data-row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 material_card_border">
                <div class="row">
                  <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                    <div class="material-name">Materials</div>
                  </div>
                  <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <div class="show_section">
                      <b-form-select v-model="selectedShowOption" :options="resourceListOptions" @change="selectoptionChange()" class="input-bg select_control mb-3 fs-12" size="sm" />
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 materials_height_alloc mb-30" v-if="materialPaginationData.length > 0">
                <div id="dataMaterials" class="links-list" v-for="(links, index) in materialPaginationData" :key="index">
                  <div class="links_list_name">
                    <div class="row">
                      <div class="col-md-1 col-lg-1 col-sm-1 col-xs-1 material_icons_stlye" :class="links.status == false ? 'disableMaterials' : ''">
                        <img v-if="getFileType(links.fileType) === 'image'" src="static/img/resource-page-img/resource-image.png" alt="" class="material-image" />
                        <img v-if="getFileType(links.fileType) === 'pdf'" src="static/img/resource-page-img/resource-pdf.png" alt="" class="material_image_style" />
                        <img v-if="getFileType(links.fileType) === 'docx'" src="static/img/resource-page-img/resource-docx1.png" alt="" class="material-image" />
                        <img v-if="getFileType(links.fileType) === 'xlsx'" src="static/img/resource-page-img/resource-xlsx.png" alt="" class="material-image" />
                        <img v-if="getFileType(links.fileType) === 'mp4'" src="static/img/resource-page-img/resource-video.png" alt="" class="material_image_mp4_style" />
                        <!-- @click="resourceVideoOpen(links)" -->
                        <i class="fa fa-file-image-o fa-lg material_icon_style" v-if="links.fileType == 'png' || links.fileType == null || links.fileType == 'jpg' || links.fileType == 'jpeg'" aria-hidden="true"></i>
                      </div>
                      <!-- <i class="fa fa-external-link fa-md" aria-hidden="true"></i >&nbsp;&nbsp;&nbsp;&nbsp; -->
                      <div class="col-md-7 col-lg-7 col-sm-7 col-xs-7 material_icons_stlye" :class="links.status == false ? 'disableMaterials' : ''">
                        <a v-if="links.title && links.status == false" :class="[links.status == false ? 'disable_material_title' : 'material_title_color', checkNewMaterial(links.createdTime) === true ? 'overflow-ellips-css' : 'overflow-ellips-woNew-css']" :title="links.title"> {{ $sanitize(links.title) }} </a>
                        <a v-if="links.title && links.status == true" :class="[links.status == true ? 'material_title_color' : 'disable_material_title', checkNewMaterial(links.createdTime) === true ? 'overflow-ellips-css' : 'overflow-ellips-woNew-css']" @click="openMaterialFile(links)" :title="links.title"> {{ $sanitize(links.title) }}</a>
                        <span class="new-material" v-if="checkNewMaterial(links.createdTime) === true">New</span>
                      </div>
                      <div class="col-md-1 col-lg-1 col-sm-1 col-xs-1" v-if="isStudyRole() === true"></div>
                      <div class="col-md-1 col-lg-1 col-sm-1 col-xs-1" v-else>
                        <button type="button" :class="enableEditOptions(links) == true ? 'btn btn-activate' : 'materialsdropdownData'" v-if="links.status == false && enableEditOptions(links) == true" @click="reactivateMaterials(links.id)">Reactivate</button>
                        <button type="button" :class="enableEditOptions(links) !== true ? 'btn btn-de-activate disableMaterials' : 'materialsdropdownData'" v-if="links.status == false && enableEditOptions(links) == true">Reactivate</button>
                      </div>

                      <div class="col-md-3 col-lg-3 col-sm-3 col-xs-3">
                        <div class="material-date">{{ new Date(links.createdTime) | dateFormat("DD MMM YYYY") }}</div>
                        <!-- dropdown start -->

                        <div class="btn-group dropleft dropdown_side" v-if="enableEditOptions(links) == true && links.status == true">
                          <img src="static/img/activity-configurator/row-settings.svg" type="button" :class="links.status == false ? 'disableMaterials' : ''" class="dropdown-toggle dropdown-toggle-split dropdown_image_material" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                          <div v-if="isStudyRole() === true" class="dropdown-menu download_material" :class="links.status == false ? 'materialsdropdownData' : ''">
                            <ul>
                              <li><div class="dropdown_labels" @click="download(links)">Download</div></li>
                            </ul>
                          </div>
                          <div v-else class="dropdown-menu dropdown_material" :class="links.status == false ? 'materialsdropdownData' : ''">
                            <ul>
                              <li><div class="dropdown_labels" @click="download(links)">Download</div></li>
                              <li><div class="dropdown_labels_another" data-toggle="modal" data-target="#edit_material_model" @click="editMaterial(links)">Edit</div></li>
                              <li><div class="dropdown_labels_another" @click="deactivateMaterial(links.id)">Deactivate</div></li>
                              <li><div class="dropdown_labels_another" @click="deleteMaterialpopOpen(links.id)">Delete</div></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- dropdown stop -->
                  </div>
                </div>
              </div>
              <div v-if="materialOverallResourcesDataList" class="materials_data_null d-flex align-items-center justify-content-center">No materials are available at this time.</div>
              <!-- pagination start -->
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-15">
                <div class="pb-0 pl-15 position-absolute bottom-0" v-if="materialPaginationData.length > 0">
                  <div class="row display-inline-flex">
                    <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 0 }">
                      <i class="fa fa-angle-left fs-23"></i>
                    </div>
                    <div class="pagination pt-3">{{ currentPage + 1 }}</div>
                    <div class="pagination2 pt-3">of {{ pageCount }}</div>
                    <div @click="nextPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage + 1 == pageCount }">
                      <i class="fa fa-angle-right fs-23"></i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- pagination end -->
            </div>
          </div>
          <br /><br />
          <!-- Materials End -->
        </div>

        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
          <!-- Links Start -->
          <div class="links-data">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 links_card_border ">
                <div class="links-name">Links</div>
              </div>
              <div></div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 links_height_alloc" v-if="gettedLinksData.length > 0">
                <div v-for="(links, index) in gettedLinksData" :key="index" :class="getResourceBorderClass(index, gettedLinksData)">
                  <div class="links_list_name">
                    <i class="fa fa-external-link fa-md links_icon" aria-hidden="true" @click="nextTabnav(links.link)"></i>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a class="links_title_color" v-if="links.title" @click="nextTabnav(links.link)" :title="links.title" :class="[checkNewMaterial(links.createdTime) === true ? 'overflow-ellips-link-css' : 'overflow-ellips-link-woNew-css']"> {{ $sanitize(links.title) }} </a>
                    <span class="new-material" v-if="checkNewMaterial(links.createdTime) === true">New</span>
                    <!-- dropdown start -->
                    <div class="btn-group dropleft dropdown_side" v-if="enableEditOptions(links) == true">
                      <img src="static/img/activity-configurator/row-settings.svg" type="button" class="btn dropdown-toggle dropdown-toggle-split dropdown_image_size" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                      <div class="dropdown-menu dropdown-links-announcement">
                        <ul>
                          <li><div class="dropdown_labels" @click="EditLinks(links)">Edit</div></li>
                          <li><div class="dropdown_labels_another" @click="deleteLinkspopOpen(links.id)">Delete</div></li>
                        </ul>
                      </div>
                    </div>
                    <!-- dropdown stop -->
                  </div>
                </div>
              </div>
              <div v-if="linksOverallResourcesDataList" class="links_data_null">No links are available at this time.</div>
            </div>
          </div>
          <!-- Links end -->

          <!-- Announcements Start -->
          <div class="announcements_data">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 links_card_border">
                <div class="announcements-name">Announcements</div>
              </div>
              <div></div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 announcement_height_alloc" v-if="gettedAnnouncementData.length > 0">
                <div v-for="(links, index) in gettedAnnouncementData" :key="index" :class="getResourceBorderClass(index, gettedAnnouncementData)">
                  <div class="announcements_list_name">
                    <div class="row">
                      <div class="col-md-1 col-lg-1">
                        <img src="static/img/resource-page-img/resource-bullhorn.png" alt="" class="announce_img_style" />
                      </div>
                      <div class="col-md-10 col-lg-10">
                        <a style="color: #007bff !important; font-size:14px" v-if="links.title" :title="links.title" :class="[checkNewMaterial(links.createdTime) === true ? 'overflow-ellips-annoc-css' : 'overflow-ellips-annoc-woNew-css']"> {{ $sanitize(links.title) }} </a>
                        <span class="new-material" v-if="checkNewMaterial(links.createdTime) === true">New</span>

                        <p :class="links.description.length > 50 ? 'announcement_data_content' : 'announcement_data_content_size_level'" v-if="links.description">
                          {{ links.description }}
                        </p>

                        <div v-if="screenSizecalculate == '1024'">
                          <a style="color: #007bff !important" v-if="links.description && links.description.length > 72" @click="readExtension(links)">Read more </a>
                        </div>
                        <div v-else-if="screenSizecalculate == '1152'">
                          <a style="color: #007bff !important" v-if="links.description && links.description.length > 92" @click="readExtension(links)">Read more </a>
                        </div>
                        <div v-else-if="screenSizecalculate == '1280'">
                          <a style="color: #007bff !important" v-if="links.description && links.description.length > 110" @click="readExtension(links)">Read more </a>
                        </div>
                        <div v-else>
                          <a style="color: #007bff !important" v-if="links.description && links.description.length > 123" @click="readExtension(links)">Read more </a>
                        </div>

                        <div v-if="links.link && readmorefield(links.description)" @click="nextTabnav(links.link)" class="announcement_title_content">{{ links.link.replace(/^https?:\/\//, "").slice(0, 40) }} <a v-if="links.link.length > 40">....</a></div>
                      </div>
                      <div class="col-md-1 col-lg-1">
                        <!-- dropdown start -->
                        <div class="btn-group dropleft dropdown_side" v-if="enableEditOptions(links) == true">
                          <img src="static/img/activity-configurator/row-settings.svg" type="button" class="btn dropdown-toggle dropdown-toggle-split dropdown_image_size" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                          <div class="dropdown-menu dropdown-links-announcement">
                            <ul>
                              <li><div class="dropdown_labels" @click="editAnnouncementData(links)">Edit</div></li>
                              <li><div class="dropdown_labels_another" @click="deleteAnnouncementpopOpen(links.id)">Delete</div></li>
                            </ul>
                          </div>
                        </div>
                        <!-- dropdown stop -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="announcementsOverallResourcesDataList" class="announcements_data_null">No announcements are available at this time.</div>
            </div>
          </div>
          <!-- Announcements End -->
        </div>
      </div>
      <!-- Materials ,Announcements , Links End -->

      <!-- Add Resource Button pop up start -->
      <div class="modal fade" id="add_Resource_model" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content add-resource-pop">
            <div class="modal-body">
              <button type="button" class="close resource-close" data-dismiss="modal">&times;</button>
              <p class="add-resource-name">Add Resources</p>
              <p class="add-resource-type">Select a resource type below to add to them to your study or site specific portal.</p>
              <button type="button" class="btn btn-modal-data" @click="addMaterialpopOpen()">Add Materials</button>
              <button type="button" class="btn btn-modal-data" @click="announcementpopOpen()">Create an Announcement</button>
              <button type="button" class="btn btn-modal-data" @click="linkspopOpen()">Add Links</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Add Resource Button pop up End -->

      <!-- Read more option pop up start  -->
      <div class="modal fade" id="read_more_extension" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content read-extension-pop">
            <div class="modal-body">
              <button type="button" class="close resource-close" data-dismiss="modal">&times;</button>
              <div v-for="(extent, index) in extensionData" :key="index">
                <div class="read-more-name" v-if="extent.title">
                  {{ extent.title
                  }}<!--{{extent.title.slice(0,32)}} -->
                  <!--<a v-if="extent.title.length>32">....</a> -->
                </div>
                <div class="read-more-content">
                  <div v-html="extent.description"></div>
                  <div v-if="extent.link" @click="nextTabnav(extent.link)" class="read_announcement_link_content">{{ extent.link.replace(/^https?:\/\//, "").slice(0, 45) }} <a v-if="extent.link.length > 45">....</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Read more option pop up end  -->

      <!-- Announcement pop up start  -->
      <div class="modal fade" id="announcement_pop" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content announce-pop">
            <div class="modal-body">
              <button type="button" class="close resource-close" @click="closeAnnounce()">&times;</button>
              <p class="create-an-announcement">Create an Announcement</p>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="announce-label">Title</label><label class="announce-star">*</label><label class="announce-char-limit">Char limit 200 chars</label>
                <input type="text" v-on:keyup="validAnnouncementTitle(announcement.title)" name="announcement-title" v-validate="'required'" :class="annTitle == true ? 'is-danger' : 'is-success'" class="form-control announce-title-box" v-model="announcement.title" placeholder="Enter title" required />
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="announce-label">Description</label><label class="announce-star">*</label><label class="announce-char-limit">Char limit 2000 chars</label>
                <textarea type="text" v-on:keydown="validateEnterPress" v-on:keyup="validAnnouncementDesc(announcement.description)" v-validate="'required'" name="announcement-description" :class="annDesc == true ? 'is-danger' : 'is-success'" class="form-control announce-description-box" v-model="announcement.description" placeholder="Enter content" required></textarea>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="announce-label">Link to article</label>
                <input type="text" class="form-control announce-article-box" v-on:keyup="validLinkUrl(announcement.link)" v-model.trim="announcement.link" placeholder="Enter URL" required />
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-padding" v-if="(canSysAdminAccess || canStudyAdminAccess) && siteDataLoaded === true">
                <label class="links-label">Select Sites</label><label class="links-star">*</label>
                <multiSelectSearch :sitesData="sites" ref="childComponent" v-on:changeSites="updateData($event)" v-on:setSitesdata="getSitesCount($event)"> </multiSelectSearch>
              </div>

              <div class="material-cancel-add">
                <button type="button" class="btn announce-cancel-btn" @click="closeAnnounce()">Cancel</button>
                <button type="button" class="btn announce-add-btn" v-on:click="addAnnouncementsData(announcement)">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Announcement pop up end  -->

      <!-- Announcement edit pop up start -->
      <div class="modal fade" id="announcement_edit_pop" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content announce-pop">
            <div class="modal-body">
              <button type="button" class="close resource-close" @click="closeAnnounce()">&times;</button>
              <p class="create-an-announcement">Edit an Announcement</p>
              <div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label class="announce-label">Title</label><label class="announce-star">*</label><label class="announce-char-limit">Char limit 200 chars</label>
                  <input type="text" v-on:keyup="editvalidAnnouncementTitle(editAnnouncements.title)" name="announcement-title" v-validate="'required'" :class="annTitle == true ? 'is-danger' : 'is-success'" class="form-control announce-title-box" v-model="editAnnouncements.title" placeholder="Enter title" required />
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label class="announce-label">Description</label><label class="announce-star">*</label><label class="announce-char-limit">Char limit 2000 chars</label>
                  <textarea type="text" v-on:keydown="validateEnterPress" v-on:keyup="editvalidAnnouncementDesc(editAnnouncements.description)" v-validate="'required'" name="announcement-description" :class="annDesc == true ? 'is-danger' : 'is-success'" class="form-control announce-description-box" v-model="editAnnouncements.description" placeholder="Enter content" required></textarea>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label class="announce-label">Link to article</label>
                  <input type="text" class="form-control announce-article-box" v-on:keyup="validLinkUrl(editAnnouncements.link)" v-model.trim="editAnnouncements.link" placeholder="Enter URL" required />
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-padding" v-if="(canSysAdminAccess || canStudyAdminAccess) && siteDataLoaded === true">
                  <label class="links-label">Select Sites</label><label class="links-star">*</label>
                  <multiSelectSearch :sitesData="sites" ref="childComponent" v-on:changeSites="updateData($event)" v-on:setSitesdata="getSitesCount($event)"> </multiSelectSearch>
                </div>

                <div class="announce-cancel-add">
                  <button type="button" class="btn announce-cancel-btn" @click="closeAnnounce()">Cancel</button>
                  <button type="button" class="btn announce-add-btn" v-on:click="EditDataAnnouncements(editAnnouncements)">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Announcement edit pop up end -->

      <!-- Links pop up start  -->
      <div class="modal fade" id="links_pop_up" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content link-pop">
            <div class="modal-body">
              <button type="button" class="close resource-close" @click="closeLinks()">&times;</button>
              <p class="add-an-link">Add a Link</p>

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="links-label">Title</label><label class="links-star">*</label><label class="links-char-limit">Char limit 200 chars</label>
                <input type="text" v-on:keyup="validLinkTitle(links.title)" name="links-title" v-validate="'required'" :class="linkTitle == true ? 'is-danger' : 'is-success'" class="form-control links-title-box" v-model="links.title" placeholder="Enter title" required />
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="links-label">Enter URL</label><label class="links-star">*</label>
                <input type="text" v-on:keyup="validLinkUrl(links.link)" name="links-url" v-validate="'required'" :class="linkUrl == true ? 'is-danger' : 'is-success'" class="form-control links-title-box" v-model="links.link" placeholder="Enter URL" required />
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-padding" v-if="(canSysAdminAccess || canStudyAdminAccess) && siteDataLoaded === true">
                <label class="links-label">Select Sites</label><label class="links-star">*</label>
                <multiSelectSearch :sitesData="sites" ref="childComponent" v-on:changeSites="updateData($event)" v-on:setSitesdata="getSitesCount($event)"> </multiSelectSearch>
              </div>

              <div class="links-cancel-add mt-8">
                <button type="button" class="btn links-cancel-btn" @click="closeLinks()">Cancel</button>
                <button type="button" class="btn links-add-btn" v-on:click="addLinksData(links)">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Links pop up end  -->

      <!-- Links edit pop up start  -->
      <div class="modal fade" id="links_edit_pop_up" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content link-pop">
            <div class="modal-body">
              <button type="button" class="close resource-close" @click="closeLinks()">&times;</button>
              <p class="add-an-link">Edit a Link</p>
              <div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label class="links-label">Title</label><label class="links-star">*</label><label class="links-char-limit">Char limit 200 chars</label>
                  <input type="text" v-on:keyup="editvalidLinkTitle(editLinksData.title)" name="links-title" v-validate="'required'" :class="linkTitle == true ? 'is-danger' : 'is-success'" class="form-control links-title-box" v-model="editLinksData.title" placeholder="Enter title" required />
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label class="links-label">Enter URL</label><label class="links-star">*</label>
                  <input type="text" v-on:keyup="editvalidLinkUrl(editLinksData.link)" name="links-url" v-validate="'required'" :class="linkUrl == true ? 'is-danger' : 'is-success'" class="form-control links-title-box" v-model="editLinksData.link" placeholder="Enter URL" required />
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 top-padding" v-if="(canSysAdminAccess || canStudyAdminAccess) && siteDataLoaded === true">
                  <label class="links-label">Select Sites</label><label class="links-star">*</label>
                  <multiSelectSearch :sitesData="sites" ref="childComponent" v-on:changeSites="updateData($event)" v-on:setSitesdata="getSitesCount($event)"> </multiSelectSearch>
                </div>

                <div class="links-cancel-add mt-8">
                  <button type="button" class="btn links-cancel-btn" @click="closeLinks()">Cancel</button>
                  <button type="button" class="btn links-add-btn" v-on:click="EditLinksMainData(editLinksData)">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Links edit pop up end  -->

      <!-- Upload and Edit Materials pop up start  -->
      <div class="modal fade" id="add_material_pop" role="dialog">
        <uploadMaterialPopup title="Upload Material"></uploadMaterialPopup>
      </div>

      <div id="edit_material_model" class="modal fade" role="dialog">
        <editMaterialPopUp title="Edit Material" :editMaterialData="editMaterialdata" :sitesData="sites"> </editMaterialPopUp>
      </div>
      <!-- Upload and Edit Materials pop up end  -->

      <!-- Announcement/Links/Upload Material successfull pop up start  -->
      <div class="modal fade" id="announcement-success-pop" role="dialog">
        <successPopup title="Announcements" successMsg="Announcement successfully published."></successPopup>
      </div>

      <div class="modal fade" id="links-success-pop" role="dialog">
        <successPopup title="Links" successMsg="Link successfully added."></successPopup>
      </div>

      <div class="modal fade" id="upload-material-success-pop" role="dialog">
        <successPopup title="Material" successMsg="Material successfully added."></successPopup>
      </div>
      <!--  Announcement/Links/Upload Material successfull pop up end  -->

      <!-- Announcement/Links/Upload Material delete pop up start  -->
      <div class="modal fade" id="links-delete-pop" role="dialog">
        <deletePopup title="Are You Sure?" successMsg="You are about to delete this link. This action cannot be undone. Would you like to continue?" type="links" :resourceDeleteId="deleteResourcesData"></deletePopup>
      </div>

      <div class="modal fade" id="announcement-delete-pop" role="dialog">
        <deletePopup title="Are You Sure?" :resourceDeleteId="deleteResourcesData" successMsg="You are about to delete this announcement. This action cannot be undone. Would you like to continue?" type="announcement"> </deletePopup>
      </div>

      <div class="modal fade" id="material-delete-pop" role="dialog">
        <deletePopup :resourceDeleteId="deleteResourcesData" title="Are You Sure?" successMsg="You are about to delete this material. This action cannot be undone. Would you like to continue?" type="material"> </deletePopup>
      </div>
      <!-- Announcement/Links/Upload Material delete pop up end  -->

      <!--Material deactivate pop up start  -->
      <div class="modal fade" id="material-deactivate-pop" role="dialog">
        <deactivatePopup :resourceDeleteId="deleteResourcesData" title="Are You Sure?" successMsg="You are about to deactivate this material. This action cannot be undone. Would you like to continue?" type="material"> </deactivatePopup>
      </div>
      <!--Material deactivate pop up End  -->

      <!--Material Reactivate pop up start  -->
      <div class="modal fade" id="material-reactivate-popup" role="dialog">
        <reactivatePopup :resourceDeleteId="deleteResourcesData" title="Are You Sure?" successMsg="You are about to reactivate this material. Would you like to continue?" type="material"> </reactivatePopup>
      </div>
      <!--Material Reactivate pop up End  -->

      <!--Material video pop up start  -->
      <div class="modal fade" id="material-video-pop" role="dialog">
        <resourceVideoPopup :resourceDeleteId="deleteResourcesData" title="Are You Sure?" successMsg="You are about to reactivate this material. Would you like to continue?" type="material"> </resourceVideoPopup>
      </div>
      <!--Material video pop up End  -->

      <!--View Material File pop up start  -->
      <div class="modal fade" id="view-material-file" role="dialog">
        <viewMaterialFile></viewMaterialFile>
      </div>
      <!--View Material File pop up End  -->

      <!-- Announcement/Links/Upload Material successfull delete pop up start  -->
      <div class="modal fade" id="announcement-delete-success-pop" role="dialog">
        <successPopup title="Announcements" successMsg="Announcement deleted successfully."></successPopup>
      </div>

      <div class="modal fade" id="links-delete-success-pop" role="dialog">
        <successPopup title="Links" successMsg="Link deleted successfully."></successPopup>
      </div>

      <div class="modal fade" id="delete-material-success-pop" role="dialog">
        <successPopup title="Material" successMsg="Material deleted successfully."></successPopup>
      </div>

      <div class="modal fade" id="deactivate-material-success-pop" role="dialog">
        <successPopup title="Material" successMsg="Material deactivated successfully."></successPopup>
      </div>

      <div class="modal fade" id="reactivated-material-success-pop" role="dialog">
        <successPopup title="Material" successMsg="Material reactivated successfully."></successPopup>
      </div>

      <div class="modal fade" id="edit-material-success-pop" role="dialog">
        <successPopup title="Material" successMsg="Material Updated successfully."></successPopup>
      </div>
      <!--  Announcement/Links/Upload Material successfull delete pop up end  -->

      <router-view :studyData="studyData" :studyId="studyId"></router-view>
    </div>
  </div>
</template>

<script>
import mainHeader from "../../components/common/main-header";
import sideMenu from "../../components/common/side-menu";
import editMaterialPopUp from "./edit-material";
import threadTrainingDashboard from "./thread-training-page";
import _ from "lodash";
import successPopup from "./success-popup";
import deletePopup from "./delete-popup";
import deactivatePopup from "./deactivate-popup";
import reactivatePopup from "./reactivate-popup";
import uploadMaterialPopup from "./upload-material";
import viewMaterialFile from "./view-material-file-popup";
import resourceVideoPopup from "./resource-video-popup";
import multiSelectSearch from "./multi-select-search";
import { mapGetters } from "vuex";
import { SYSTEM_ADMIN, STUDY_ADMIN, PI, SUB_PI, STUDY_COORDINATOR, CC, SUPPORT } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import filter from "lodash/filter";
import axios from "axios";

export default {
  name: "resource-list",
  components: { mainHeader, successPopup, deactivatePopup, reactivatePopup, viewMaterialFile, deletePopup, sideMenu, editMaterialPopUp, multiSelectSearch, threadTrainingDashboard, uploadMaterialPopup, resourceVideoPopup },
  data() {
    return {
      sites: [],
      materialOverallResourcesDataList: false,
      linksOverallResourcesDataList: false,
      announcementsOverallResourcesDataList: false,
      editMaterialdata: {
        title: "",
        description: ""
      },
      imgFilePath: "static/img/resource-page-img/resource-video.png",
      materialFiledata: "",
      deleteResourcesData: "",
      studyData: {},
      screenSizecalculate: "",
      siteDataLoaded: false,
      isSiteSelected: false,
      piRoleName: "",
      piRoleUniqueId: "",
      studyId: this.$route.params.studyId,
      searchResourceTerm: null,
      resourceListFlag: true,
      // announcement
      validAnnoncementTitleValue: false,
      validAnnoncementDescValue: false,
      validEditAnnoncementTitleValue: false,
      validEditAnnoncementDescValue: false,
      annTitle: false,
      annDesc: false,
      announcement: {
        createdBy: "",
        type: "",
        title: "",
        description: "",
        link: "",
        studySiteMeta: [],
        allSitesSelected: false
      },
      //material
      material: {
        name: "",
        file: ""
      },
      validmaterialNameValue: false,
      materialName: false,
      isFileSelected: false,
      editAnnouncements: {
        id: "",
        type: "",
        title: "",
        description: "",
        link: ""
      },
      // Links
      valid_Annoncement_Title_Value: false,
      valid_Annoncement_Desc_Value: false,
      validLinksTitleValue: false,
      validLinksUrlValue: false,
      valid_Links_Title_Value: false,
      valid_Links_Url_Value: false,
      linkTitle: false,
      linkUrl: false,
      links: {
        createdBy: "",
        type: "",
        title: "",
        link: "",
        studySiteMeta: [],
        allSitesSelected: false
      },
      pageNumber: 0,
      gettedLinksData: [],
      gettedAnnouncementData: [],
      gettedmaterialsData: [],
      searchgettedLinksData: [],
      searchgettedAnnouncementData: [],
      searchgettedmaterialsData: [],
      editLinksData: {},
      extensionData: [{ title: "", description: "", link: "" }],
      currentPage: 0,
      totalPages: 0,
      selectedShowOption: 15,
      resourceListOptions: [
        {
          value: 15,
          text: "Show 15 items"
        },
        {
          value: 30,
          text: "Show 30 items"
        },
        {
          value: 50,
          text: "Show 50 items"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    pageCount() {
      let l = this.gettedmaterialsData.length;

      let s = this.selectedShowOption;
      return Math.ceil(l / s);
    },
    materialPaginationData() {
      let start = this.currentPage * this.selectedShowOption;

      let end = start + this.selectedShowOption;
      return this.gettedmaterialsData.slice(start, end);
    }
  },
  methods: {
    isStudyRole() {
      if (this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "Interviewer" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") {
        return true;
      } else {
        return false;
      }
    },
    enableEditOptions(resourceData) {
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator") {
        if (resourceData.userRole == "Pi" || resourceData.userRole == "SubPi" || resourceData.userRole == "StudyCoordinator") {
          return true;
        }
      } else if (this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin") {
        if (resourceData.userRole == "SystemAdmin" || resourceData.userRole == "StudyAdmin") {
          return true;
        }
      } else if ((this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "Interviewer" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") && resourceData.type === "material") {
        if (resourceData.userRole == "SystemAdmin" || resourceData.userRole == "StudyAdmin") {
          return true;
        }
      }
    },
    downloadImageWithAxios(fileURL, fileName) {
      axios({
        method: "get",
        url: fileURL,
        responseType: "arraybuffer"
      }).then(response => {
        this.forceFileDownload(response, fileName);
      });
    },
    forceFileDownload(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    getResourceBorderClass(index, data) {
      if (index + 1 === data.length) {
        return "";
      } else {
        return "links-list";
      }
    },
    readmorefield(data) {
      if (this.screenSizecalculate == "1024" && data.length > 72) {
        return false;
      } else if (this.screenSizecalculate == "1152" && data.length > 92) {
        return false;
      } else if (this.screenSizecalculate == "1280" && data.length > 110) {
        return false;
      } else if (data.length > 123) {
        return false;
      } else {
        return true;
      }
    },
    getFileType(filetype) {
      if (filetype.includes("image")) {
        return "image";
      } else if (filetype.includes("pdf")) {
        return "pdf";
      } else if (filetype.includes("mp4")) {
        return "mp4";
      } else if (filetype.includes("wordprocessingml.document")) {
        return "docx";
      } else if (filetype.includes("spreadsheetml.sheet")) {
        return "xlsx";
      }
      return "none";
    },
    getNewMaterialCount() {
      let daysDiffCount = 0;
      this.gettedmaterialsData.map(el => {
        let datevalue = new Date(el.createdTime);
        let currentDate = new Date();
        let diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
        if (diffDays <= 10) {
          daysDiffCount++;
        }
      });
      this.$store.state.newMaterialCount = daysDiffCount;
      return daysDiffCount;
    },
    checkNewMaterial(date) {
      let currentDate = new Date();
      let datevalue = new Date(date);
      let diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
      if (diffDays <= 10) {
        return true;
      } else {
        return false;
      }
    },
    selectoptionChange() {
      this.currentPage = 0;
    },
    validateEditAnn() {
      let flag = false;
      if (this.editAnnouncements.description) {
        if (this.editAnnouncements.description.length > 2000) {
          flag = true;
        }
      }
      if (this.editAnnouncements.title > 200) {
        if (this.editAnnouncements.title.length > 200) {
          flag = true;
        }
      }
      return flag;
    },
    async getSitesdata() {
      let sitesdata = [];
      let sitesArray = [];
      await this.$api.getSitesData(this.studyId).then(response => {
        if (response.body) {
          // sitesdata = response.body;
          sitesdata = response.body.sort(function(a, b) {
            return a.userSiteId.localeCompare(b.userSiteId, undefined, {
              numeric: true,
              sensitivity: "base"
            });
          });
        }
      });

      await sitesdata.map(el => {
        let siteObject = {
          name: "",
          id: "",
          check: false,
          values: []
        };
        let values = {
          display_name: "",
          data_id: "",
          check: false
        };

        //country data
        siteObject.name = el.countryList[0].countryName;
        siteObject.id = el.countryList[0].countryId;
        siteObject.check = false;

        //site data
        values.display_name = el.userSiteId + " " + el.name;
        values.data_id = el.userSiteId;
        values.check = false;
        siteObject.values.push(values);
        sitesArray.push(siteObject);
      });

      //formatted Sites Array
      let formattedSites = [];
      let index = 0;
      sitesArray.map(el => {
        if (index === 0) {
          formattedSites.push(el);
        } else {
          let flag = false;
          formattedSites.map(items => {
            if (el.name === items.name) {
              flag = true;
              items.values.push(el.values[0]);
            }
          });
          if (flag === false) {
            formattedSites.push(el);
          }
        }
        index++;
      });
      // formattedSites.map(el=>{
      //   el.values.sort(this.sortSites);
      // });
      this.sites = formattedSites;
      this.siteDataLoaded = true;
    },
    sortSites(a, b) {
      if (a.display_name < b.display_name) {
        return -1;
      } else if (a.display_name > b.display_name) {
        return 1;
      } else {
        return 0;
      }
    },
    getSitesCount(data) {
      this.sites = data;
      let count = this.$store.state.selectedSitesCount;
      if (count > 0) {
        this.isSiteSelected = true;
      } else {
        this.isSiteSelected = false;
      }
    },
    updateData(data) {
      if (data === true) {
        this.isSiteSelected = true;
        this.sites.map(el => {
          el.check = true;
          el.values.map(item => {
            item.check = true;
          });
        });
      } else {
        this.isSiteSelected = false;
        this.sites.map(el => {
          el.check = false;
          el.values.map(item => {
            item.check = false;
          });
        });
      }
    },
    async getStudyDetails() {
      this.studyData = JSON.parse(window.localStorage.getItem("studyDetailsData"));
      if (this.studyData === null) {
        let result = await this.$api.getStudyDataFact(this.studyId);
        this.studyData = result.body;
      }
    },
    getParticularPIrole() {
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "CallCenter") {
        let getSiteIdDetails = JSON.parse(window.localStorage.getItem("getSiteIdDetails"));
        if (getSiteIdDetails === null) {
          this.$api.getSiteDetailsFact(this.studyId, this.user.siteIds[0]).then(response => {
            this.piRoleName = response.body.name;
            this.piRoleUniqueId = response.body.userSiteId;
            return new Promise(resolve => {
              resolve({ piRoleUniqueId: this.piRoleUniqueId, piRoleName: this.piRoleName });
            });
          });
        } else {
          this.piRoleName = getSiteIdDetails.name;
          this.piRoleUniqueId = getSiteIdDetails.userSiteId;
          return new Promise(resolve => {
            resolve({ piRoleUniqueId: this.piRoleUniqueId, piRoleName: this.piRoleName });
          });
        }
      }
    },
    searchResourceList() {
      this.materialOverallResourcesDataList = false;
      this.linksOverallResourcesDataList = false;
      this.announcementsOverallResourcesDataList = false;
      if (this.searchResourceTerm.trim()) {
        let searLink = this.searchgettedLinksData;
        this.gettedLinksData = filter(searLink, form => form.title.toLowerCase().includes(this.searchResourceTerm.trim().toLowerCase()));
        let searAnnoun = this.searchgettedAnnouncementData;
        this.gettedAnnouncementData = filter(searAnnoun, form => form.title.toLowerCase().includes(this.searchResourceTerm.trim().toLowerCase()) || form.description.toLowerCase().includes(this.searchResourceTerm.trim().toLowerCase()));
        let searmater = this.searchgettedmaterialsData;
        this.gettedmaterialsData = filter(searmater, form => form.title.toLowerCase().includes(this.searchResourceTerm.trim().toLowerCase()));
        this.currentPage = 0;
        if (this.gettedmaterialsData.length == 0) {
          this.materialOverallResourcesDataList = true;
        }
        if (this.gettedLinksData.length == 0) {
          this.linksOverallResourcesDataList = true;
        }
        if (this.gettedAnnouncementData.length == 0) {
          this.announcementsOverallResourcesDataList = true;
        }
      } else {
        this.getResourcesData();
      }
    },
    readExtension(extensionList) {
      this.extensionData = [{ title: extensionList.title, description: extensionList.description, link: extensionList.link }];
      window.$("#read_more_extension").modal({ backdrop: "static", keyboard: false }, "show");
    },
    prevPage() {
      this.currentPage--;
    },
    nextPage() {
      this.currentPage++;
    },
    announcementpopOpen() {
      window.$("#add_Resource_model").modal("hide");
      this.$root.$emit("resources_data_list", 0);
      window.$("#announcement_pop").modal({ backdrop: "static", keyboard: false }, "show");
      this.validLinksUrlValue = false;
      this.sites.map(el => {
        el.check = false;
        el.values.map(item => {
          item.check = false;
        });
      });
    },
    addMaterialpopOpen() {
      this.$root.$emit("resources_data_list", 0);
      window.$("#add_Resource_model").modal("hide");
      window.$("#add_material_pop").modal({ backdrop: "static", keyboard: false }, "show");
      this.validLinksUrlValue = false;
    },
    // Announcement title validation
    validAnnouncementTitle(announcementtitleVal) {
      if (!(this.announcement.title || announcementtitleVal) || this.announcement.title.length > 200 || announcementtitleVal.length > 200) {
        this.annTitle = true;

        if (announcementtitleVal && ((this.announcement && this.announcement.title && this.announcement.title.length > 200) || announcementtitleVal.length > 200)) {
          this.$toastr.error("Title cannot exceed 200 characters in length.");
        }
      } else {
        this.annTitle = false;
      }
      const announcePattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,199}[a-zA-Z0-9]");
      if (announcePattern.test(announcementtitleVal)) {
        this.valid_Annoncement_Title_Value = false;
      } else {
        this.valid_Annoncement_Title_Value = true;
      }
    },
    editvalidAnnouncementTitle(announcementtitleVal) {
      if (!(this.announcement.title || announcementtitleVal) || this.announcement.title.length > 200 || announcementtitleVal.length > 200) {
        this.annTitle = true;

        if (announcementtitleVal && ((this.announcement && this.announcement.title && this.announcement.title.length > 200) || announcementtitleVal.length > 200)) {
          this.$toastr.error("Title cannot exceed 200 characters in length.");
        }
      } else {
        this.annTitle = false;
      }
      const announcePattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,199}[a-zA-Z0-9]");
      if (announcePattern.test(announcementtitleVal)) {
        this.validAnnoncementTitleValue = false;
      } else {
        this.validAnnoncementTitleValue = true;
      }
    },

    // Edit Announcement title validation
    validEditAnnouncementTitle(announcementtitleVal) {
      if (!(this.editAnnouncements.title || announcementtitleVal) || this.editAnnouncements.title.length > 200 || announcementtitleVal.length > 200) {
        this.annTitle = true;
      } else {
        this.annTitle = false;
      }
      const announcePattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,199}[a-zA-Z0-9]");
      if (announcePattern.test(announcementtitleVal)) {
        this.validEditAnnoncementTitleValue = false;
      } else {
        this.validEditAnnoncementTitleValue = true;
      }
    },

    // Announcement description validation
    validAnnouncementDesc(announcementdescVal) {
      if (!(this.announcement.description || announcementdescVal) || this.announcement.description.length > 2000 || announcementdescVal.length > 2000) {
        this.annDesc = true;

        if (announcementdescVal && ((this.announcement && this.announcement.description && this.announcement.description.length > 2000) || announcementdescVal.length > 2000)) {
          this.$toastr.error("Description cannot exceed 2000 characters in length.");
        }
      } else {
        this.annDesc = false;
      }
      const announcePattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,1999}[a-zA-Z0-9]");
      if (announcePattern.test(announcementdescVal)) {
        this.valid_Annoncement_Desc_Value = false;
      } else {
        this.valid_Annoncement_Desc_Value = true;
      }
    },
    editvalidAnnouncementDesc(announcementdescVal) {
      if (!(this.announcement.description || announcementdescVal) || this.announcement.description.length > 2000 || announcementdescVal.length > 2000) {
        this.annDesc = true;

        if (announcementdescVal && ((this.announcement && this.announcement.description && this.announcement.description.length > 2000) || announcementdescVal.length > 2000)) {
          this.$toastr.error("Description cannot exceed 2000 characters in length.");
        }
      } else {
        this.annDesc = false;
      }
      const announcePattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,1999}[a-zA-Z0-9]");
      if (announcePattern.test(announcementdescVal)) {
        this.validAnnoncementDescValue = false;
      } else {
        this.validAnnoncementDescValue = true;
      }
    },

    // Edit Announcement description validation
    validEditAnnouncementDesc(announcementdescVal) {
      if (!(this.editAnnouncements.description || announcementdescVal) || this.editAnnouncements.description.length > 2000 || announcementdescVal.length > 2000) {
        this.annDesc = true;
      } else {
        this.annDesc = false;
      }
      const announcePattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,1999}[a-zA-Z0-9]");
      if (announcePattern.test(announcementdescVal)) {
        this.validEditAnnoncementDescValue = false;
      } else {
        this.validEditAnnoncementDescValue = true;
      }
    },
    validateAddAnnouncementData(announcement) {
      let isError = true;
      this.validAnnouncementTitle(announcement.title);

      if (this.valid_Annoncement_Title_Value && announcement.title.length < 200) {
        this.$toastr.error("Please add a title.");
        return isError;
      } else if (announcement.title && announcement.title.length > 200) {
        this.$toastr.error("Title cannot exceed 200 characters in length.");
        return isError;
      }
      this.validAnnouncementDesc(announcement.description);

      if (this.valid_Annoncement_Desc_Value && announcement.description.length < 2000) {
        this.$toastr.error("Please add a description.");
        return isError;
      } else if (announcement.description && announcement.description.length > 2000) {
        this.$toastr.error("Description cannot exceed 2000 characters in length.");
        return isError;
      }

      this.validLinkUrl(announcement.link);

      if (this.valid_Links_Url_Value && announcement.link && announcement.link.length) {
        this.$toastr.error("Please add a valid URL.");
        return isError;
      }

      if ((this.canSysAdminAccess && this.resourceListFlag) || (this.canStudyAdminAccess && this.resourceListFlag)) {
        this.$toastr.error("Please select a site.");
        return isError;
      }

      isError = false;
      return isError;
    },
    addAnnouncementsData(announcement) {
      if (this.validateAddAnnouncementData(announcement)) {
        return;
      }

      this.sites.map(el => {
        el.check = false;
        el.values.map(item => {
          item.check = false;
        });
      });
      this.announcement.createdBy = this.user.id;
      this.announcement.type = "announcement";
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        this.announcement.studySiteMeta = [{ siteId: this.piRoleUniqueId, siteName: this.piRoleName }];
      } else {
        this.announcement.studySiteMeta = this.$store.state.materialSitesData;
      }
      this.announcement.description = this.announcement.description.replace(/ /g, "\u00a0").replace(/\n/g, "  ");
      this.$api.addResourcesCreation(this.studyId, this.announcement).then(
        response => {
          if (response) {
            window.$("#announcement_pop").modal("hide");
            window.$("#announcement-success-pop").modal({ backdrop: "static", keyboard: false }, "show");
            //this.$root.$emit('resource_uploaded',true);
            this.getResourcesData();
            this.announcementsOverallResourcesDataList = false;
            this.screenSizecalculate = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            this.announcement = { title: "", description: "", link: "", studySiteMeta: [], allSitesSelected: false };
            this.annDesc = this.annTitle = this.valid_Links_Url_Value = this.valid_Annoncement_Desc_Value = this.valid_Annoncement_Title_Value = false;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites.");
        }
      );
    },
    closeAnnounce() {
      this.sites.map(el => {
        el.check = false;
        el.values.map(item => {
          item.check = false;
        });
      });
      this.announcement = { title: "", description: "", link: "", studySiteMeta: "" };
      this.$root.$emit("close_material", true);
      window.$("#announcement_pop").modal("hide");
      window.$("#announcement_edit_pop").modal("hide");
      this.resourceListFlag = true;
      this.annDesc = this.annTitle = this.validAnnoncementTitleValue = this.validAnnoncementDescValue = this.linkUrl = this.valid_Links_Url_Value = this.valid_Annoncement_Desc_Value = this.valid_Annoncement_Title_Value = false;
    },
    // Links open pop up
    linkspopOpen() {
      window.$("#add_Resource_model").modal("hide");
      this.$root.$emit("resources_data_list", 0);
      window.$("#links_pop_up").modal({ backdrop: "static", keyboard: false }, "show");
      this.sites.map(el => {
        el.check = false;
        el.values.map(item => {
          item.check = false;
        });
      });
    },
    // Links delete pop up
    deleteLinkspopOpen(deleteData) {
      this.deleteResourcesData = deleteData;
      window.$("#add_Resource_model").modal("hide");
      window.$("#links-delete-pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    deleteAnnouncementpopOpen(deleteData) {
      this.deleteResourcesData = deleteData;
      window.$("#add_Resource_model").modal("hide");
      window.$("#announcement-delete-pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    deleteMaterialpopOpen(deleteData) {
      this.deleteResourcesData = deleteData;
      window.$("#add_Resource_model").modal("hide");
      window.$("#material-delete-pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    deactivateMaterial(id) {
      this.deleteResourcesData = id;
      window.$("#add_Resource_model").modal("hide");
      window.$("#material-deactivate-pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    resourceVideoOpen(data) {
      this.$root.$emit("getvideoProcess", data);
      window.$("#material-video-pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    openMaterialFile(materialData) {
      //if((this.getFileType(materialData.fileType) == "image") || (this.getFileType(materialData.fileType) == "pdf") || (this.getFileType(materialData.fileType) == "mp4") ){
      this.$root.$emit("showMaterialFile", materialData);
      window.$("#view-material-file").modal({ backdrop: "static", keyboard: false }, "show");
      //}
    },
    reactivateMaterials(id) {
      this.deleteResourcesData = id;
      window.$("#material-reactivate-popup").modal({ backdrop: "static", keyboard: false }, "show");
    },
    validateLinkData(links) {
      let isError = true;
      this.validLinkTitle(links.title);

      if (this.valid_Links_Title_Value && links.title.length < 200) {
        this.$toastr.error("Please add a title.");
        return isError;
      } else if (links.title && links.title.length > 200) {
        this.$toastr.error("Title cannot exceed 200 characters in length.");
        return isError;
      }
      this.validLinkUrl(links.link);

      if (this.valid_Links_Url_Value) {
        this.$toastr.error("Please add a valid URL.");
        return isError;
      }

      if ((this.canSysAdminAccess && this.resourceListFlag) || (this.canStudyAdminAccess && this.resourceListFlag)) {
        this.$toastr.error("Please select a site.");
        return isError;
      }

      isError = false;
      return isError;
    },
    async addLinksData(link) {
      if (this.validateLinkData(link)) {
        return;
      }

      this.sites.map(el => {
        el.check = false;
        el.values.map(item => {
          item.check = false;
        });
      });
      this.links.createdBy = this.user.id;
      this.links.type = "links";
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        this.links.studySiteMeta = [{ siteId: this.piRoleUniqueId, siteName: this.piRoleName }];
      } else {
        this.links.studySiteMeta = this.$store.state.materialSitesData;
      }
      await this.$api.addResourcesCreation(this.studyId, this.links).then(
        response => {
          if (response) {
            this.getResourcesData();
            //this.$root.$emit('resource_uploaded',true);
            this.linksOverallResourcesDataList = false;
            window.$("#links_pop_up").modal("hide");
            window.$("#links-success-pop").modal({ backdrop: "static", keyboard: false }, "show");
            this.links = { title: "", link: "", studySiteMeta: [], allSitesSelected: false };
            this.linkUrl = this.linkTitle = this.valid_Links_Url_Value = this.valid_Links_Title_Value = false;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites.");
        }
      );
    },
    closeLinks() {
      this.sites.map(el => {
        el.check = false;
        el.values.map(item => {
          item.check = false;
        });
      });
      this.links = {
        title: "",
        link: ""
      };
      this.$root.$emit("close_material", true);
      window.$("#links_pop_up").modal("hide");
      window.$("#links_edit_pop_up").modal("hide");
      this.resourceListFlag = true;
      this.linkUrl = this.linkTitle = this.validLinksUrlValue = this.validLinksTitleValue = this.valid_Links_Url_Value = this.valid_Links_Title_Value = false;
    },
    validLinkTitle(linkstitleVal) {
      if (!(this.links.title || linkstitleVal) || this.links.title.length > 200 || linkstitleVal.length > 200) {
        this.linkTitle = true;

        if (linkstitleVal && ((this.links && this.links.title && this.links.title.length > 200) || linkstitleVal.length > 200)) {
          this.$toastr.error("Title cannot exceed 200 characters in length.");
        }
      } else {
        this.linkTitle = false;
      }
      const linksPattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,199}[a-zA-Z0-9]");
      if (linksPattern.test(linkstitleVal)) {
        this.valid_Links_Title_Value = false;
      } else {
        this.valid_Links_Title_Value = true;
      }
    },
    editvalidLinkTitle(linkstitleVal) {
      if (!(this.links.title || linkstitleVal) || this.links.title.length > 200 || linkstitleVal.length > 200) {
        this.linkTitle = true;

        if (linkstitleVal && ((this.links && this.links.title && this.links.title.length > 200) || linkstitleVal.length > 200)) {
          this.$toastr.error("Title cannot exceed 200 characters in length.");
        }
      } else {
        this.linkTitle = false;
      }
      const linksPattern = new RegExp("^[a-zA-Z]{0}[a-zA-Z0-9]{0,199}[a-zA-Z0-9]");
      if (linksPattern.test(linkstitleVal)) {
        this.validLinksTitleValue = false;
      } else {
        this.validLinksTitleValue = true;
      }
    },

    validLinkUrl(linksUrlVal) {
      if (!(this.links.url || linksUrlVal)) {
        this.linkUrl = true;
      } else {
        this.linkUrl = false;
      }
      const linksPattern = /^(ftp:\/\/|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
      if (linksUrlVal && linksPattern.test(linksUrlVal.trim())) {
        this.valid_Links_Url_Value = false;
      } else {
        this.valid_Links_Url_Value = true;
      }
    },
    editvalidLinkUrl(linksUrlVal) {
      if (!(this.links.url || linksUrlVal)) {
        this.linkUrl = true;
      } else {
        this.linkUrl = false;
      }
      const linksPattern = /^(ftp:\/\/|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
      if (linksPattern.test(linksUrlVal.trim())) {
        this.validLinksUrlValue = false;
      } else {
        this.validLinksUrlValue = true;
      }
    },
    //Edit material Data
    async editMaterial(data) {
      let materialData = data;
      await this.$api.getOneResourceData(data.id).then(response => {
        materialData = response.body;
        this.resourceListFlag = false;
      });
      this.$root.$emit("editMaterial", materialData);
      this.editMaterialdata = data;
      this.sites.map(el => {
        el.values.map(val => {
          data.studySiteMeta.map(items => {
            if (val.data_id === items.siteId) {
              val.check = true;
            }
          });
        });
      });
      window.$("#edit_material_model").modal({ backdrop: "static", keyboard: false }, "show");
    },

    // Edit links validation start
    EditLinks(data) {
      this.sites.map(el => {
        el.values.map(val => {
          data.studySiteMeta.map(items => {
            if (val.data_id === items.siteId) {
              val.check = true;
            }
          });
        });
      });
      this.$api.getOneResourceData(data.id).then(response => {
        this.editLinksData = response.body;
        this.resourceListFlag = false;
      });
      window.$("#links_edit_pop_up").modal({ backdrop: "static", keyboard: false }, "show");
    },
    async checkSites(id) {
      await this.$api.getOneResourceData(id).then(response => {
        if (response) {
          let studySitedata = response.body.studySiteMeta;
          let siteMetaDataArray = [];
          this.$store.state.materialSitesData.map(data => {
            let count = 0;
            studySitedata.map(el => {
              if (data.siteId === el.siteId) {
                count++;
              }
            });
            if (count === 0) {
              siteMetaDataArray.push(data);
            }
          });

          this.$store.state.sitesData = siteMetaDataArray;
        }
      });
    },
    validateEditLinkData(editLinksData) {
      let isError = true;
      this.editvalidLinkTitle(editLinksData.title);

      if (this.validLinksTitleValue && editLinksData.title.length < 200) {
        this.$toastr.error("Please add a title.");
        return isError;
      } else if ((editLinksData.title && editLinksData.title.length > 200) || (this.links && this.links.title && this.links.title.length > 200)) {
        this.$toastr.error("Title cannot exceed 200 characters in length.");
        return isError;
      }

      this.editvalidLinkUrl(editLinksData.link);

      if (this.validLinksUrlValue) {
        this.$toastr.error("Please add a valid URL.");
        return isError;
      }

      if ((this.canSysAdminAccess && this.resourceListFlag) || (this.canStudyAdminAccess && this.resourceListFlag)) {
        this.$toastr.error("Please select a site.");
        return isError;
      }

      isError = false;
      return isError;
    },
    async EditLinksMainData(data) {
      if (this.validateEditLinkData(data)) {
        return;
      }

      this.checkSites(data.id);

      let studySiteMeta = this.$store.state.materialSitesData;
      if (!this.$store.state.materialSitesData) {
        studySiteMeta = data.studySiteMeta;
      }
      let editLinkData = {
        userRole: data.userRole,
        id: data.id,
        createdBy: data.createdBy,
        type: data.type,
        title: data.title,
        link: data.link,
        studyId: this.studyId,
        studySiteMeta: studySiteMeta
      };
      await this.$api.editResource(data.id, editLinkData).then(response => {
        if (response) {
          this.getResourcesData();
          this.linksOverallResourcesDataList = false;
        }
      });
      window.$("#links_edit_pop_up").modal("hide");
      window.$("#links-success-pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    // Edit links validation End
    // Edit Announcement
    editAnnouncementData(announceData) {
      this.$api.getOneResourceData(announceData.id).then(response => {
        this.editAnnouncements = response.body;
        this.resourceListFlag = false;
      });
      // this.editAnnouncements = announceData;
      this.sites.map(el => {
        el.values.map(val => {
          announceData.studySiteMeta.map(items => {
            if (val.data_id === items.siteId) {
              val.check = true;
            }
          });
        });
      });
      window.$("#announcement_edit_pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    validateEditAnnouncementData(editAnnouncements) {
      let isError = true;

      this.editvalidAnnouncementTitle(editAnnouncements.title);

      if (this.validAnnoncementTitleValue && editAnnouncements.title.length < 200) {
        this.$toastr.error("Please add a title.");
        return isError;
      } else if (editAnnouncements.title && editAnnouncements.title.length > 200) {
        this.$toastr.error("Title cannot exceed 200 characters in length.");
        return isError;
      }
      this.editvalidAnnouncementDesc(editAnnouncements.description);

      if (this.validAnnoncementDescValue && editAnnouncements.description.length < 2000) {
        this.$toastr.error("Please add a description.");
        return isError;
      } else if (editAnnouncements.description && editAnnouncements.description.length > 2000) {
        this.$toastr.error("Description cannot exceed 2000 characters in length.");
        return isError;
      }

      this.validLinkUrl(editAnnouncements.link);

      if (this.valid_Links_Url_Value && editAnnouncements.link && editAnnouncements.link.length) {
        this.$toastr.error("Please add a valid URL.");
        return isError;
      }

      if ((this.canSysAdminAccess && this.resourceListFlag) || (this.canStudyAdminAccess && this.resourceListFlag)) {
        this.$toastr.error("Please select a site.");
        return isError;
      }

      isError = false;
      return isError;
    },
    async EditDataAnnouncements(data) {
      if (this.validateEditAnnouncementData(data)) {
        return;
      }

      let studySiteMeta = this.$store.state.materialSitesData;
      if (!this.$store.state.materialSitesData) {
        studySiteMeta = data.studySiteMeta;
      }
      let editAnnouncementData = {
        link: data.link,
        userRole: data.userRole,
        id: data.id,
        title: data.title,
        description: data.description,
        createdBy: data.createdBy,
        studySiteMeta: studySiteMeta,
        studyId: this.studyId,
        type: data.type
      };
      editAnnouncementData.description = editAnnouncementData.description.replace(/ /g, "\u00a0").replace(/\n/g, "  ");
      await this.$api.editResource(data.id, editAnnouncementData).then(response => {
        if (response) {
          this.getResourcesData();
          this.valid_Links_Url_Value = false;
          this.announcementsOverallResourcesDataList = false;
          this.screenSizecalculate = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        }
      });
      window.$("#announcement_edit_pop").modal("hide");
      window.$("#announcement-success-pop").modal({ backdrop: "static", keyboard: false }, "show");
    },
    nextTabnav(tabUrl) {
      window.open(tabUrl);
    },
    async download(data) {
      let videofile = {
        studyId: this.studyId,
        filePath: data.filePath
      };
      this.$api.getPresignedURL(videofile).then(response => {
        if (data.fileType.includes("image") || data.fileType.includes("pdf") || data.fileType.includes("mp4")) {
          this.downloadImageWithAxios(response.body.preSignedUrl, data.fileName);
        } else {
          window.open(response.body.preSignedUrl);
        }
      });
      // this.generateSurveyPdf().then(pdf => {
      //   var filename = "Resources_" + this.studyId + ".pdf";
      //   pdf.save(filename);
      // });
    },
    // async generateSurveyPdf() {
    //   let val = "#dataMaterials"
    //   return new Promise(async resolveComplete => {
    //     var doc = new jspdf();
    //     let promise = [];
    //     let pdf = new jspdf("p", "mm", "a4");
    //     var width = pdf.internal.pageSize.getWidth();
    //       await new Promise(async resolve => {
    //         html2canvas(document.querySelector(val), {
    //           allowTaint: true,
    //           useCORS: true
    //         }).then(canvas => {
    //             pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0,10, width, 0);
    //           resolve();
    //         });
    //       });
    //     resolveComplete(pdf);
    //   })
    // },
    async getResourcesData() {
      this.materialOverallResourcesDataList = false;
      this.linksOverallResourcesDataList = false;
      this.announcementsOverallResourcesDataList = false;
      this.searchResourceTerm = "";
      let materialOrderSequence;
      let linkOrderSequence;
      let announcementOrderSequence;
      await this.$api.getAllResourcesData(this.studyId, "material").then(
        response => {
          if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "CallCenter") {
            materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
            let dataResource = [];
            let dataSitesResource = [];
            let overallListResource = [];
            materialOrderSequence.forEach(elementData => {
              dataResource = elementData;
              dataSitesResource = elementData.studySiteMeta;
              dataSitesResource.forEach(elementList => {
                if (elementList.siteId == this.piRoleUniqueId) {
                  overallListResource.push(dataResource);
                }
              });
            });
            materialOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
          } else if (this.user.userRole == "Cra" || this.user.userRole == "Interviewer" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") {
            let materialData = _.orderBy(response.body, "createdTime", "desc");
            materialOrderSequence = materialData.filter(el => {
              return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
            });
          } else {
            materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites.");
        }
      );
      await this.$api.getAllResourcesData(this.studyId, "links").then(
        response => {
          if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "CallCenter") {
            linkOrderSequence = _.orderBy(response.body, "title", "asc");
            let dataResource = [];
            let dataSitesResource = [];
            let overallListResource = [];
            linkOrderSequence.forEach(elementData => {
              dataResource = elementData;
              dataSitesResource = elementData.studySiteMeta;
              dataSitesResource.forEach(elementList => {
                if (elementList.siteId == this.piRoleUniqueId) {
                  overallListResource.push(dataResource);
                }
              });
            });
            linkOrderSequence = _.orderBy(overallListResource, "title", "asc");
          } else if (this.user.userRole == "Cra" || this.user.userRole == "Interviewer" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") {
            let linksData = _.orderBy(response.body, "title", "asc");
            linkOrderSequence = linksData.filter(el => {
              return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
            });
          } else {
            linkOrderSequence = _.orderBy(response.body, "title", "asc");
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites.");
        }
      );
      await this.$api.getAllResourcesData(this.studyId, "announcement").then(
        response => {
          if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "CallCenter") {
            announcementOrderSequence = _.orderBy(response.body, "createdTime", "desc");
            let dataResource = [];
            let dataSitesResource = [];
            let overallListResource = [];
            announcementOrderSequence.forEach(elementData => {
              dataResource = elementData;
              dataSitesResource = elementData.studySiteMeta;
              dataSitesResource.forEach(elementList => {
                if (elementList.siteId == this.piRoleUniqueId) {
                  overallListResource.push(dataResource);
                }
              });
            });
            announcementOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
          } else if (this.user.userRole == "Cra" || this.user.userRole == "Interviewer" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") {
            let annData = _.orderBy(response.body, "createdTime", "desc");
            announcementOrderSequence = annData.filter(el => {
              return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
            });
          } else {
            announcementOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites.");
        }
      );
      if (materialOrderSequence.length == 0) {
        this.materialOverallResourcesDataList = true;
      }
      if (linkOrderSequence.length == 0) {
        this.linksOverallResourcesDataList = true;
      }
      if (announcementOrderSequence.length == 0) {
        this.announcementsOverallResourcesDataList = true;
      }
      this.gettedmaterialsData = materialOrderSequence;
      this.searchgettedmaterialsData = materialOrderSequence;
      this.gettedAnnouncementData = announcementOrderSequence;
      this.searchgettedAnnouncementData = announcementOrderSequence;
      this.gettedLinksData = linkOrderSequence;
      this.searchgettedLinksData = linkOrderSequence;
    },
    validateEnterPress(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    }
  },
  async mounted() {
    this.screenSizecalculate = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    await this.getParticularPIrole();
    this.getStudyDetails();
    setTimeout(() => {
      this.getResourcesData();
    }, 3200);
    this.$root.$on("materialDataResponse", () => {
      this.getResourcesData();
      this.materialOverallResourcesDataList = false;
      this.searchResourceTerm = "";
    });
    this.$root.$on("deleteResourcesList", () => {
      this.getResourcesData();
    });
  },
  created() {
    this.getSitesdata();
    this.$root.$on("resources_data_list", resourceData => {
      if (resourceData == 0) {
        this.resourceListFlag = true;
      } else {
        this.resourceListFlag = false;
      }
    });
  }
};
</script>

<style scoped lang="scss">
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  padding: 0px;
}
.material-image {
  margin: -6px 5px 0px 0px;
  width: 18px;
}
.new-material {
  padding: 1px 7px 2px 8px;
  border-radius: 4px;
  margin: 8px;
  background-color: #4c8ce4;
  color: white;
  font-size: 12px;
  font-family: "RobotoRegular";
}
.main-container {
  display: flex;
  background-color: #f5f6f7 !important;
}
.has-header {
  margin-top: 70px !important;
}
.has-sidemenu {
  margin-left: 0px !important;
  padding-top: 0px !important;
  overflow: auto;
}
.form-container {
  width: 100%;
}
// Dropdown Size
.dropdown_image_size {
  width: 23px;
  position: relative;
  bottom: 5px;
}
.dropdown_image_material {
  width: 21px;
  position: relative;
  top: 3px;
  left: 65px;
}
.dropdown_side {
  float: right;
}
/deep/ .dropdown-links-announcement.show {
  position: absolute;
  will-change: transform;
  top: 0px;
  width: 46px;
  height: 74px !important;
  min-width: 6rem;
  top: 0px !important;
  left: 6px !important;
  box-shadow: 0px 1px 1px 2px #f5f8fa;
}
/deep/ .dropdown_material.show {
  position: absolute;
  will-change: transform;
  top: 0px;
  width: 46px;
  height: 146px !important;
  min-width: 6rem;
  top: 0px !important;
  left: 6px !important;
  box-shadow: 0px 1px 1px 2px #f5f8fa;
}

/deep/ .download_material.show {
  position: absolute;
  will-change: transform;
  top: -13px !important;
  width: 46px;
  height: 38px !important;
  min-width: 6rem;
  left: 6px !important;
  box-shadow: 0px 1px 1px 2px #f5f8fa;
}
ul li {
  list-style-type: none;
  border-bottom: 1px solid#d3dfe4;
  width: 94px;
  position: relative;
  right: 40px;
  font-size: 14px;
}
.dropdown_labels {
  position: relative;
  left: 11px;
  height: 28px;
  top: 0px !important;
  font-family: "RobotoRegular";
  font-size: 12px;
  line-height: 1.67;
  text-align: left;
  color: #000000;
}
.dropdown_labels_another {
  position: relative;
  left: 11px;
  height: 35px;
  top: 6px !important;
  font-family: "RobotoRegular";
  font-size: 12px;
  line-height: 1.67;
  text-align: left;
  color: #000000;
}
// search option
.search-resource-field {
  padding: 8px !important;
  background-image: url("/static/img/search1.svg");
  background-repeat: no-repeat;
  background-position: 97% 50%;
  color: #2d3752;
  border: 1px solid #e4e8eb !important;
  width: 370px;
  height: 35px;
  margin: 28px 331px 16.5px 19.9px;
  box-shadow: none;
}

// Add resource button

.btn-resource {
  font-family: "RobotoRegular";
  font-size: 13px;
  line-height: 1.23;
  color: #4c8ce4;
  width: 121px;
  height: 35px;
  float: right;
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
  margin: 28px 0px 16.5px 19.9px;
  box-shadow: none;
}

// Links css
.links-data {
  width: 420px;
  height: 230.5px;
  margin: 6px 89px 23.3px 14.5px;
  padding: 0 0 12.5px;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
  background-color: #ffffff;
}
.links-name {
  width: 34px;
  height: 16px;
  margin: 10px 0px 12px 2px !important;
  font-family: "RobotoMedium";
  font-size: 14px;
  font-weight: 500;
  color: #666669 !important;
  position: relative;
  left: 10px;
}
.links_card_border {
  border-bottom: 1px solid #d3dee3;
}
.links_list_name {
  height: 10px;
  margin: 12px 0px 18px 18px !important;
  font-family: "RobotoRegular";
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.links-list {
  border-bottom: 1px solid #d3dee3;
}
.links_data_null {
  font-size: 14px;
  position: absolute;
  margin: 88px;
  top: 38px;
  font-family: "RobotoRegular";
  font-weight: 600;
  color: #9b9b9b;
}
.links_height_alloc {
  overflow-x: hidden;
  height: 188px;
}
// Announcements
.announcements_data {
  width: 420px;
  height: 294px;
  margin: 11.5px 89px 23.3px 14.5px;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
  background-color: #ffffff;
}
.announcements-name {
  width: 34px;
  height: 16px;
  margin: 10px 0px 12px 2px !important;
  font-family: "RobotoMedium";
  font-size: 14px;
  font-weight: 500;
  color: #666669 !important;
  position: relative;
  left: 10px;
}
.announcements_list_name {
  margin: 8px 0px 12px 18px !important;
  font-family: "RobotoRegular";
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.announcement_data_content {
  width: 343px;
  height: 35.5px;
  margin: 3px 12.5px 0 0px;
  overflow: hidden;
  word-break: break-all;
  font-family: "RobotoRegular";
  font-size: 12px;
  text-align: left;
  color: #000000;
  cursor: default;
}
.announcement_data_content_size_level {
  width: 343px;
  height: auto !important;
  margin: 3px 12.5px 0 0px;
  overflow: hidden;
  word-break: break-all;
  font-family: "RobotoRegular";
  font-size: 12px;
  text-align: left;
  color: #000000;
  cursor: default;
}
.announcement_title_content {
  position: relative;
  font-family: "RobotoRegular";
  font-size: 13px;
  text-align: left;
  color: #000000;
  margin: 2px 0px 0px 0px;
  color: #007bff;
}
.read_announcement_link_content {
  position: relative;
  font-family: "RobotoRegular";
  font-size: 14px;
  text-align: left;
  color: #000000;
  margin: 2px 0px 0px 0px;
  color: #007bff;
  cursor: pointer !important;
}
.announcement_title_content:hover {
  color: #007bff;
}
.announcements_data_null {
  font-size: 14px;
  position: relative;
  top: 38px;
  margin: 66px;
  font-family: "RobotoRegular";
  font-weight: 600;
  color: #9b9b9b;
}
.announcement_height_alloc {
  // overflow: scroll;
  overflow-x: hidden;
  height: 252px;
}
.announcement_height_alloc,
.links_height_alloc,
.materials_height_alloc,
.read-more-content {
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 transparent;
}
.announcement_height_alloc::-webkit-scrollbar,
.links_height_alloc::-webkit-scrollbar,
.read-more-content::-webkit-scrollbar,
.materials_height_alloc::-webkit-scrollbar {
  width: 5px;
  border: 3px solid transparent;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
.announcement_height_alloc::-webkit-scrollbar-thumb,
.read-more-content::-webkit-scrollbar-thumb,
.materials_height_alloc::-webkit-scrollbar-thumb,
.links_height_alloc::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 20px;
  border: 2px solid transparent;
}
.announcement_height_alloc::-webkit-scrollbar-thumb:window-inactive,
.read-more-content::-webkit-scrollbar-thumb:window-inactive,
.materials_height_alloc::-webkit-scrollbar-thumb:window-inactive,
.links_height_alloc::-webkit-scrollbar-thumb:window-inactive {
  background-color: #c4c4c4;
  border-radius: 20px;
  border: 2px solid transparent;
}
// Materials
.materials-data {
  height: 548px;
  border-radius: 4px;
  margin: 24px 10.5px 0px 18px;
  border: solid 1px #c5d1d6;
  background-color: #ffffff;
}
.material-name {
  width: 34px;
  height: 16px;
  margin: 10px 0px 12px 2px !important;
  font-family: "RobotoMedium";
  font-size: 14px;
  font-weight: 500;
  color: #666669 !important;
  position: relative;
  left: 10px;
}
.materials_data_null {
  font-size: 14px;
  font-family: "RobotoRegular";
  font-weight: 600;
  color: #9b9b9b;
  height: 92%;
  padding: 50px;
  width: 100%;
}
.materials_height_alloc {
  height: 430px;
  overflow-x: hidden;
}
// select option
.input-bg {
  background: #ffffff !important;
  color: #4a4a4a !important;
  border: 1px solid #e4e8eb !important;
}
.select_control {
  background-repeat: no-repeat;
  border: none;
}
.show_section {
  select.form-control {
    width: 150px;
    margin: 3px 6px 2px 2px;
    height: 30.5px;
    padding: 0 13px 0 10px;
    border-radius: 3px;
    float: right;
    -webkit-box-shadow: inset 0 1px 2px 0 #e4e8eb;
    box-shadow: inset 0 1px 2px 0 #e4e8eb;
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
  }
}
.show_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #1e8fe1;
  right: 10px;
  top: 8px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  position: absolute;
  pointer-events: none;
}

.show_section.siteId:after,
.show_section.country:after,
.show_section.langugage:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  right: 25px;
  top: 8px;
  position: absolute;
}
.material_card_border {
  border-bottom: 1px solid #d3dee3;
  padding: 3px;
}
.material-date {
  float: right;
  position: relative;
  right: 40px;
  bottom: 1px;
}
// pagination style

.disabledPagination {
  pointer-events: none;
}
.position-absolute {
  position: absolute;
}
.bottom-0 {
  bottom: 0px;
}
.display-inline-flex {
  display: inline-flex !important;
}
/deep/ .arrow-icon {
  width: 26px;
  height: 27px;
  border-radius: 3px;
  padding: 0px 0px 0px 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}
/deep/ .pagination {
  width: 26px;
  height: 27px;
  border-radius: none;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  padding: 0px 0px 0px 10px;
  border: solid 1px #d8d8d8;
  background-color: #ffffff;
  font-size: 13px;
  color: #4a4a4a;
}

/deep/ .pagination2 {
  width: 40px;
  height: 27px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}
.add_resource_btn {
  width: 433px;
}
.badge-new-item {
  background-color: #4c8ce4;
  color: #ffffff;
  font-size: 12px;
  padding: 0 6px 1px;
  border-radius: 4px;
  margin-left: 2px;
}

// Responsive in main screen
@media (max-width: 1050px) {
  .links-data,
  .announcements_data {
    width: 285px;
  }
  .announcement_data_content {
    width: 225px;
    overflow: hidden;
    word-break: break-all;
  }
  .announcement_data_content_size_level {
    width: 225px;
    overflow: hidden;
    word-break: break-all;
    height: auto !important;
  }
  .add_resource_btn {
    width: unset;
  }
  .btn-resource {
    position: relative;
    right: 40px;
  }
}
@media (min-width: 1050px) and (max-width: 1220px) {
  .links-data,
  .announcements_data {
    width: 325px;
  }
  .announcement_data_content {
    width: 255px;
    overflow: hidden;
    word-break: break-all;
  }
  .announcement_data_content_size_level {
    width: 255px;
    overflow: hidden;
    height: auto !important;
    word-break: break-all;
  }
  .add_resource_btn {
    width: unset;
  }
  .btn-resource {
    position: relative;
    right: 50px;
  }
}
@media (min-width: 1220px) and (max-width: 1280px) {
  .links-data,
  .announcements_data {
    width: 380px;
  }
  .add_resource_btn {
    width: unset;
  }
  .announcement_data_content {
    width: 300px;
    overflow: hidden;
    word-break: break-all;
  }
  .announcement_data_content_size_level {
    width: 300px;
    height: auto !important;
    overflow: hidden;
    word-break: break-all;
  }
  .btn-resource {
    position: relative;
    right: 50px;
  }
}
@media (max-width: 1366px) {
  .has-sidemenu {
    margin-left: 0px !important;
    padding-top: 0px !important;
  }
}
@media (min-width: 1390px) and (max-width: 1500px) {
  .has-sidemenu {
    margin-left: 23px !important;
    padding-top: 0px !important;
  }
}
@media (min-width: 1560px) and (max-width: 1800px) {
  .has-sidemenu {
    margin-left: 82px !important;
    padding-top: 0px !important;
  }
}
@media (min-width: 1800px) {
  .has-sidemenu {
    margin-left: 130px !important;
    padding-top: 0px !important;
  }
}

// Modal pop up Add resource design

.create-an-announcement,
.add-an-link {
  height: 20px;
  font-family: "RobotoRegular";
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.btn-modal-data {
  width: 231px;
  height: 35px;
  margin: 8px 2px 2.5px 58.5px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  color: #4c8ce4;
  background-color: white;
}
.add-resource-pop {
  width: 380px;
  height: 320px;
  padding: 0.4px 0 0;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
.add-resource-name {
  font-family: "RobotoRegular";
  font-size: 20px;
  margin: 4px 0px 10px 2px;
  line-height: 1;
  padding: 0px;
  color: #666669;
}
.add-resource-type {
  width: 292px;
  position: relative;
  bottom: 2px;
  padding: 3px;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  color: #666669;
}
button.resource-close {
  position: relative;
  left: 7px;
  bottom: 10px;
  font-size: 18px;
}
// Read more option css
.read-extension-pop {
  width: 394px;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
.read-more-name {
  width: 100%;
  height: auto;
  margin: 0px 115.5px 20px 6px;
  font-family: "RobotoRegular";
  font-size: 20px;
  line-height: 1.1;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.read-more-content {
  width: 340px;
  height: 165px;
  overflow-x: hidden;
  word-break: break-all !important;
  margin: 0px 0 8.9px 6px;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #666669;
}
// Announcement pop up css
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
  position: relative;
  bottom: 14px;
}
.is-danger {
  border-width: 2px;
  border-color: #f16559 !important;
}
.announce-pop,
.link-pop,
.material-pop {
  width: 394px;
  padding: 0px 0px 0px 8px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
.announce-title-box,
.announce-article-box,
.links-title-box {
  width: 343px;
  height: 33px;
  margin: 2px 0px 17px 0px;
  padding: 1.9px 30px 0 10px;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.announce-description-box {
  width: 343px;
  height: 130px;
  resize: none;
  margin: 2px 0px 17px 0px;
  padding: 3.1px 30px 4.7px 10px;
  background-color: #ffffff;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.announce-label,
.links-label {
  height: 10px;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #666669;
}
.announce-star,
.links-star {
  color: #f16559;
  position: relative;
  left: 3px;
  bottom: 3px;
  margin-bottom: 0px !important;
}
.announce-char-limit,
.links-char-limit {
  float: right;
  font-family: "RobotoRegular";
  font-size: 9px;
  line-height: 2.22;
  text-align: center;
  color: #959fa4;
  height: 20px;
  margin: 3px 12px 0px 0px;
}
.announce-cancel-add,
.links-cancel-add,
.material-cancel-add {
  float: right;
  margin: 0px 13px 10px 0px;
}
.announce-add-btn,
.links-add-btn,
.material-add-btn {
  width: 82px;
  height: 32px;
  margin: 0 0 0 6px;
  padding: 0px 0 0px;
  border-radius: 4px;
  background-color: #4c8ce4;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  color: #ffffff;
}
.announce-cancel-btn,
.links-cancel-btn,
.material-cancel-btn {
  width: 82px;
  height: 32px;
  margin: 0 0 0 18px;
  padding: 0px 0 0px;
  border-radius: 4px;
  font-family: "RobotoRegular";
  font-size: 14px;
  line-height: 1.43;
  color: #b0bac9;
  background-color: #ffffff;
}
.disabledbtn {
  background-color: #d3dfe4 !important;
  pointer-events: none;
  border: #d3dfe4 !important;
}
::placeholder {
  font-size: 14px;
  color: #c5d1d6;
}
.btn-activate {
  // width: 60px;
  height: 24px;
  font-family: "RobotoRegular";
  font-size: 12px;
  line-height: 0;
  text-align: center;
  color: #4c8ce4;
  border-radius: 4px;
  position: relative;
  bottom: 3px;
  right: 10px;
  box-shadow: none;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
  padding: 0px 8px 0px 8px;
}
.material_icons_stlye {
  position: relative;
  bottom: 2px;
}
.material_title_color {
  color: #007bff !important;
  position: relative;
  bottom: 1px;
  margin-left: -18px;
}
.links_title_color {
  color: #007bff !important;
  position: relative;
  bottom: 1px;
}
/deep/ i.fa.fa-external-link.fa-md.links_icon {
  font-size: 1.13em;
}
.announce_img_style {
  margin: -2px 0px 0px -8px;
}
.material_image_style {
  margin: -6px 6px 0px -5px;
}
.material_icon_style {
  margin: 0px 13px 0px 0px;
}
.material_image_mp4_style {
  margin: -4px 11px 0px 0px;
  width: 20px;
  height: 20px;
}
.disableMaterials {
  cursor: no-drop !important;
  color: grey !important;

  // pointer-events: none !important;
}
.disable_material_title {
  color: grey !important;
  position: relative;
  bottom: 1px;
  margin-left: -18px;
  cursor: no-drop !important;
}
.btn-de-activate {
  // width: 60px;
  height: 24px;
  font-family: "RobotoRegular";
  font-size: 12px;
  line-height: 0;
  text-align: center;
  color: #4c8ce4;
  border-radius: 4px;
  position: relative;
  bottom: 3px;
  right: 10px;
  box-shadow: none;
  border: solid 1px grey;
  background-color: #ffffff;
}
.materialsdropdownData {
  display: none;
}
.overflow-ellips-css {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  max-width: calc(100% - 45px);
  vertical-align: text-top;
}
.overflow-ellips-woNew-css {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  max-width: 100%;
}
.overflow-ellips-link-css {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  max-width: calc(80% - 41px);
  vertical-align: text-top;
}
.overflow-ellips-link-woNew-css {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  max-width: 80%;
}
.overflow-ellips-annoc-css {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  max-width: calc(100% - 57px);
  vertical-align: text-top;
}
.overflow-ellips-annoc-woNew-css {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  max-width: 100%;
}
.material-data-row {
  height: auto;
  position: relative;
}
</style>
